// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1A77l","colMin":"styles_colMin__wXN1J","colCheckbox":"styles_colCheckbox__D33-1"};